// Gallery images from src/assets
import img_1 from '../assets/tekke-sangli.jpeg';
import asthaImg from '../assets/tekke-Astha.jpeg';
import athaniImg from '../assets/tekke-Athani.jpeg';
import solapurImg from '../assets/tekke-solapur.jpeg';
import img_2 from '../assets/WhatsApp Image 2026-10-17 at 7.58.28 AM (1).jpeg';
import img_3 from '../assets/WhatsApp Image 2026-10-17 at 7.58.28 AM.jpeg';
import img_4 from '../assets/WhatsApp Image 2026-10-17 at 7.58.29 AM (1).jpeg';
import img_5 from '../assets/WhatsApp Image 2026-10-17 at 7.58.29 AM.jpeg';
import img_6 from '../assets/WhatsApp Image 2026-10-17 at 7.58.30 AM (1).jpeg';
import img_7 from '../assets/WhatsApp Image 2026-10-17 at 7.58.30 AM (2).jpeg';
import img_8 from '../assets/WhatsApp Image 2026-10-17 at 7.58.30 AM.jpeg';
import img_9 from '../assets/WhatsApp Image 2026-10-17 at 7.58.31 AM (1).jpeg';
import img_10 from '../assets/WhatsApp Image 2026-10-17 at 7.58.31 AM.jpeg';
import img_11 from '../assets/WhatsApp Image 2026-10-17 at 7.58.32 AM (1).jpeg';
import img_12 from '../assets/WhatsApp Image 2026-10-17 at 7.58.32 AM.jpeg';
import img_13 from '../assets/WhatsApp Image 2026-10-17 at 7.58.33 AM (1).jpeg';
import img_14 from '../assets/WhatsApp Image 2026-10-17 at 7.58.33 AM.jpeg';
import img_15 from '../assets/WhatsApp Image 2026-10-17 at 7.58.34 AM (1).jpeg';
import img_16 from '../assets/WhatsApp Image 2026-10-17 at 7.58.34 AM.jpeg';
import img_17 from '../assets/WhatsApp Image 2026-10-17 at 7.58.35 AM (1).jpeg';
import img_18 from '../assets/WhatsApp Image 2026-10-17 at 7.58.35 AM.jpeg';
import img_19 from '../assets/WhatsApp Image 2026-10-17 at 7.58.36 AM (1).jpeg';
import img_20 from '../assets/WhatsApp Image 2026-10-17 at 7.58.36 AM (2).jpeg';
import img_21 from '../assets/WhatsApp Image 2026-10-17 at 7.58.36 AM.jpeg';
import img_22 from '../assets/WhatsApp Image 2026-10-17 at 7.58.37 AM (1).jpeg';
import img_23 from '../assets/WhatsApp Image 2026-10-17 at 7.58.37 AM.jpeg';
import img_24 from '../assets/WhatsApp Image 2026-10-17 at 7.58.38 AM.jpeg';
import img_25 from '../assets/WhatsApp Image 2026-10-17 at 7.58.39 AM (1).jpeg';
import img_26 from '../assets/WhatsApp Image 2026-10-17 at 7.58.40 AM (1).jpeg';
import img_27 from '../assets/WhatsApp Image 2026-10-17 at 7.58.41 AM (1).jpeg';
import img_28 from '../assets/WhatsApp Image 2026-10-17 at 7.58.41 AM.jpeg';
import img_29 from '../assets/WhatsApp Image 2026-10-17 at 7.58.42 AM (1).jpeg';
import img_30 from '../assets/WhatsApp Image 2026-10-17 at 7.58.42 AM (2).jpeg';
import img_31 from '../assets/WhatsApp Image 2026-10-17 at 7.58.42 AM.jpeg';
import img_32 from '../assets/WhatsApp Image 2026-10-17 at 7.58.43 AM (1).jpeg';
import img_33 from '../assets/WhatsApp Image 2026-10-17 at 7.58.43 AM.jpeg';
import img_34 from '../assets/WhatsApp Image 2026-10-17 at 7.58.44 AM (1).jpeg';
import img_35 from '../assets/WhatsApp Image 2026-10-17 at 7.58.44 AM.jpeg';
import img_36 from '../assets/WhatsApp Image 2026-10-17 at 7.58.45 AM (1).jpeg';
import img_37 from '../assets/WhatsApp Image 2026-10-17 at 7.58.45 AM.jpeg';
import img_38 from '../assets/WhatsApp Image 2026-10-17 at 7.58.46 AM (1).jpeg';
import img_39 from '../assets/WhatsApp Image 2026-10-17 at 7.58.46 AM (2).jpeg';
import img_40 from '../assets/WhatsApp Image 2026-10-17 at 7.58.46 AM.jpeg';
import img_41 from '../assets/WhatsApp Image 2026-10-17 at 7.58.47 AM.jpeg';

export const gallery = [
  {
    id: 1,
    url: img_1,
    category: "Hospital & Clinics",
    title: "Sree Tekke Eye Hospital - Sangli Main Center"
  },
  {
    id: 101,
    url: asthaImg,
    category: "Hospital & Clinics",
    title: "Sree Teke Eye Clinic - Astha Branch"
  },
  {
    id: 102,
    url: athaniImg,
    category: "Hospital & Clinics",
    title: "Sree Teke Eye Clinic - Athani Branch"
  },
  {
    id: 103,
    url: solapurImg,
    category: "Hospital & Clinics",
    title: "Raghvendra Sree Teke Eye Clinic - Solapur Branch"
  },
  {
    id: 2,
    url: img_2,
    category: "Camps & Outreach",
    title: "Rashtriya Netra Yagna - Free Eye Surgeries"
  },
  {
    id: 3,
    url: img_3,
    category: "Our Team & Doctors",
    title: "Medical Team & Doctors at Sangli Reception"
  },
  {
    id: 4,
    url: img_4,
    category: "Our Team & Doctors",
    title: "Clinic Team Gathering & Celebrations"
  },
  {
    id: 5,
    url: img_5,
    category: "Our Team & Doctors",
    title: "Clinical Staff & Leadership Team"
  },
  {
    id: 6,
    url: img_6,
    category: "Patient Care & OPD",
    title: "Bustling OPD & Patient Care Service"
  },
  {
    id: 7,
    url: img_7,
    category: "Patient Care & OPD",
    title: "Patient Waiting Lounge & Guidance"
  },
  {
    id: 8,
    url: img_8,
    category: "Hospital & Clinics",
    title: "Sree Teke Eye Clinic Kolhapur Branch Team"
  },
  {
    id: 9,
    url: img_9,
    category: "Camps & Outreach",
    title: "Diabetic Retinopathy Awareness Rally"
  },
  {
    id: 10,
    url: img_10,
    category: "Camps & Outreach",
    title: "World Diabetes Day Community Awareness"
  },
  {
    id: 11,
    url: img_11,
    category: "Camps & Outreach",
    title: "Community Eye Health Walkathon"
  },
  {
    id: 12,
    url: img_12,
    category: "Camps & Outreach",
    title: "Youth & Volunteer Eye Camp Outreach"
  },
  {
    id: 13,
    url: img_13,
    category: "Patient Care & OPD",
    title: "Patient Vision Restoration Felicitation"
  },
  {
    id: 14,
    url: img_14,
    category: "Hospital & Clinics",
    title: "Kolhapur Branch Opening & Staff"
  },
  {
    id: 15,
    url: img_15,
    category: "Our Team & Doctors",
    title: "Medical Team Training & Life Support Session"
  },
  {
    id: 16,
    url: img_16,
    category: "Our Team & Doctors",
    title: "COLS Life Support Workshop with Doctors & Staff"
  },
  {
    id: 17,
    url: img_17,
    category: "Our Team & Doctors",
    title: "Staff Festival Celebration & Team Spirit"
  },
  {
    id: 18,
    url: img_18,
    category: "Our Team & Doctors",
    title: "Festive Moments at Tekke Eye Hospital"
  },
  {
    id: 19,
    url: img_19,
    category: "Camps & Outreach",
    title: "Community Eye Screening & Awareness Drive"
  },
  {
    id: 20,
    url: img_20,
    category: "Camps & Outreach",
    title: "Patient Registration at Free Eye Camp"
  },
  {
    id: 21,
    url: img_21,
    category: "Camps & Outreach",
    title: "Eye Health Education & Outreach"
  },
  {
    id: 22,
    url: img_22,
    category: "Our Team & Doctors",
    title: "Staff Birthday Celebration with Doctors"
  },
  {
    id: 23,
    url: img_23,
    category: "Our Team & Doctors",
    title: "Doctor & Staff Celebration Gathering"
  },
  {
    id: 24,
    url: img_24,
    category: "Our Team & Doctors",
    title: "Anniversary Celebration with Dr. Vishakha Tekke"
  },
  {
    id: 25,
    url: img_25,
    category: "Our Team & Doctors",
    title: "Tekke Clinic Doctors & Staff Team"
  },
  {
    id: 26,
    url: img_26,
    category: "Patient Care & OPD",
    title: "Post-Surgery Patient Ward & Care"
  },
  {
    id: 27,
    url: img_27,
    category: "Our Team & Doctors",
    title: "Clinical Staff Assembly"
  },
  {
    id: 28,
    url: img_28,
    category: "Our Team & Doctors",
    title: "Hospital Directors & Medical Team"
  },
  {
    id: 29,
    url: img_29,
    category: "Our Team & Doctors",
    title: "National Festival Celebration at Clinic"
  },
  {
    id: 30,
    url: img_30,
    category: "Patient Care & OPD",
    title: "Patient Care Consultation"
  },
  {
    id: 31,
    url: img_31,
    category: "Our Team & Doctors",
    title: "Independence Day Celebration at Tekke Eye Care"
  },
  {
    id: 32,
    url: img_32,
    category: "Our Team & Doctors",
    title: "Consultation Room Team Selfie"
  },
  {
    id: 33,
    url: img_33,
    category: "Our Team & Doctors",
    title: "Clinical & Optometry Staff Group"
  },
  {
    id: 34,
    url: img_34,
    category: "Patient Care & OPD",
    title: "Eye Care Awareness Gathering"
  },
  {
    id: 35,
    url: img_35,
    category: "Our Team & Doctors",
    title: "Hospital Team Presentation at Reception"
  },
  {
    id: 36,
    url: img_36,
    category: "Patient Care & OPD",
    title: "Patient Counseling & Guidance"
  },
  {
    id: 37,
    url: img_37,
    category: "Patient Care & OPD",
    title: "Eye Donation Awareness Session for Patients"
  },
  {
    id: 38,
    url: img_38,
    category: "Patient Care & OPD",
    title: "OPD Waiting Hall & Awareness"
  },
  {
    id: 39,
    url: img_39,
    category: "Patient Care & OPD",
    title: "Patient Awareness Talk in OPD"
  },
  {
    id: 40,
    url: img_40,
    category: "Patient Care & OPD",
    title: "Interactive Patient Health Lecture"
  },
  {
    id: 41,
    url: img_41,
    category: "Patient Care & OPD",
    title: "Patient Engagement & Education"
  }
];
